export default function registerStart (lf) {
  lf.register('start', ({ CircleNode, CircleNodeModel, h }) => {
    class StartNode extends CircleNode {

      getIconShape () {
        const {model} = this.props
        const {
          x,
          y,
          width,
          height
        } = model
        const stroke = '#F9AA68'
        return h(
            'svg',
            {
              x: x - width / 2,
              y: y - height / 2,
              width: 40,
              height: 40,
              viewBox: '0 0 1024 1024'
            },
            h(
                'path',
                {
                  fill: stroke,
                  d: 'M212.992 526.336 212.992 526.336 212.992 526.336 215.04 526.336 212.992 526.336Z'
                }
            ),
            h(
                'path',
                {
                  fill: '#F9AA68',
                  d: 'M433.055 354.37l1.232 315.652c0.066 16.882 19.502 26.319 32.809 15.931l200.806-156.759c10.393-8.113 10.421-23.825 0.057-31.976L465.922 338.325c-13.355-10.502-32.933-0.945-32.867 16.045z'
                }
            )
        )
      }
      getShape () {
        const {model} = this.props
        const {
          x,
          y,
          r,
        } = model
        const {
          fill,
          stroke,
          strokeWidth} = model.getNodeStyle()
        return h(
          'g',
          {
          },
          [
            h(
              'circle',
              {
                cx: x,
                cy: y,
                r,
                fill,
                stroke,
                strokeWidth
              }
            ),
            this.getIconShape()
            // this.getLabelShape()
          ]
        )
      }
    }
    class StartModel extends CircleNodeModel {
      // 自定义节点形状属性
      initNodeData(data) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 35,
          dragable: false,
          editable: true
        }
        super.initNodeData(data)
        this.r = 20
      }
      // 自定义节点样式属性
      getNodeStyle() {
        const style = super.getNodeStyle()
        return style
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
      // 自定义节点outline
      getOutlineStyle() {
        const style = super.getOutlineStyle();
        style.stroke = '#88f'
        return style
      }
      getConnectedTargetRules () {
        const rules = super.getConnectedTargetRules()
        const notAsTarget = {
          message: '起始节点不能作为连线的终点',
          validate: () => false
        }
        rules.push(notAsTarget)
        return rules
      }
    }
    return {
      view: StartNode,
      model: StartModel
    }
  })
}
